import React, { ReactElement } from 'react';

interface PhoneFieldProps {
  phone?: string;
}

// eslint-disable-next-line react/prop-types
export default function PhoneField({ phone }: PhoneFieldProps): ReactElement | null {
  if (phone) {
    return (
      <span>
        <a href={`tel:${phone}`}>{phone}</a>
      </span>
    );
  }
  return null;
}
